import React, { useEffect } from 'react';
import NavBar from './NavBar';
import './Whitepaper.css';

function Whitepaper() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="whitepaper-page">
      <NavBar />

      <section className="whitepaper-hero">
        <div className="whitepaper-hero-content">
          <h1>Whitepaper</h1>
          <p className="whitepaper-subtitle">Orchestral AI: A Framework for Multi-Agent Orchestration</p>
        </div>
      </section>

      <div className="whitepaper-content">
        <div className="pdf-container">
          <iframe
            src="/whitepaper.pdf"
            title="Orchestral AI Whitepaper"
            className="pdf-viewer"
          />
        </div>
        <div className="download-section">
          <a href="/whitepaper.pdf" download className="download-button">
            Download PDF
          </a>
        </div>
      </div>
    </div>
  );
}

export default Whitepaper;
